import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
const useCountAnimation = (value, t0) => {
  const $ = _c(6);
  const duration = t0 === undefined ? 500 : t0;
  const [displayValue, setDisplayValue] = useState(value);
  const animationRef = useRef(undefined);
  const startTimeRef = useRef(undefined);
  const startValueRef = useRef(value);
  let t1;
  let t2;
  if ($[0] !== duration || $[1] !== value) {
    t1 = () => {
      if (startValueRef.current === value) {
        return;
      }
      const startValue = startValueRef.current;
      const endValue = value;
      const difference = endValue - startValue;
      const animate = currentTime => {
        if (!startTimeRef.current) {
          startTimeRef.current = currentTime;
        }
        const elapsed = currentTime - startTimeRef.current;
        const progress = Math.min(elapsed / duration, 1);
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = startValue + difference * easeOut;
        setDisplayValue(currentValue);
        if (progress < 1) {
          animationRef.current = requestAnimationFrame(animate);
        } else {
          startValueRef.current = endValue;
          startTimeRef.current = undefined;
        }
      };
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      animationRef.current = requestAnimationFrame(animate);
      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    };
    t2 = [value, duration];
    $[0] = duration;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
    t4 = [];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return displayValue;
};
export default useCountAnimation;